import { useState, useEffect, Suspense } from "react";
import { shortenData, dateFormat } from "../../utils/formatting";
import Select_Input from "../UI/Select_Input";
import { getRequest, postRequest } from "../../apiService";
import Button from "../button/Button";
import { elevatedAccess } from "../../utils/elevatedAccess";
export function SmartCallList() {
  const [inputs, setInputs] = useState({});
  const [callList_selectOptions, setCallList_selectOptions] = useState([]);
  const [smartList, setSmartList] = useState([]);

  useEffect(() => {
    //add check here if need to display smart call list due to user type
    if (
      Number(sessionStorage.getItem("user-accessLevel")) <= 3 &&
      sessionStorage.getItem("department") === "BSS"
    ) {
      const userId = sessionStorage.getItem("user-id");
      getSmartCallList_selects();
      getSmartCallList(userId);
    }
  }, []);

  async function getSmartCallList_selects() {
    try {
      const result = await getRequest("type/getRequestedType/?id=42");

      if (result.success) {
        setCallList_selectOptions(result.data.data);
      } else {
        console.error(
          "Failed to load smart call select options:",
          result.error
        );
      }
    } catch (error) {
      console.error("Error loading smart call select options:", error);
    }
  }

  async function getSmartCallList(id) {
    try {
      const result = await getRequest(
        `smartList/getSmartList/?id=${Number(id)}`
      );

      if (result.success) {
        setSmartList(result.data.data);
        setInputs((values) => ({
          ...values,
          ["agentActive_SmartCallList"]: id,
        }));
      } else {
        console.error("Failed to load smart call list:", result.error);
      }
    } catch (error) {
      console.error("Error loading smart call list:", error);
    }
  }

  function updateSelectFields(inputField, newValue) {
    setInputs((values) => ({ ...values, [inputField]: newValue }));
    if(window.innerWidth < 900){
      const listing_id = inputField.substring(inputField.lastIndexOf('_')+1, inputField.length);
      // alert(listing_id);
      const selectedAction = callList_selectOptions.filter((f)=> f.id == newValue)[0];
      const index = smartList.findIndex((f)=> f.listing_id == listing_id)-1;
      const targetData = smartList.filter((f)=> f.listing_id == listing_id)[0];
      console.log(index);
    if(confirm(
      "Confirm changing of '"+targetData.Contact+"' appraisal to: "+selectedAction.name+"?"
    ) === true){
      actionAppraisal(Number(listing_id), index+1, newValue);
    }else{
      setInputs((values) => ({ ...values, [inputField]: 0 }));
    }
    }
    
  }

  const activateSmartCallViewing = async () => {
    let agentName = prompt(
      "Please enter your agent full name: e.g. Marcus Chiminello",
      "Marcus Chiminello"
    );
    try {
      const result = await getRequest(
        `user/getUserDetails/?name=${agentName.toLowerCase()}`
      );

      if (result.success) {
        if (Number(result.data.data[0].id) > 0) {
          callList_selectOptions.length < 1 ? getSmartCallList_selects() : null;
          getSmartCallList(Number(result.data.data[0].id));
        }
      } else {
        console.error(
          "Failed to retrieve agent for smart call list:",
          result.error
        );
      }
    } catch (error) {
      console.error("Error retrieving agent for smart call list:", error);
    }
  };

  function deactivateSmartCallViewing() {
    const newInputs = Object.fromEntries(
      Object.entries(inputs).filter(([key]) => !key.startsWith("agentActive_"))
    );
    setInputs(newInputs);
  }

  const actionAppraisal = async (listing_id, index, actionTaken) => {
     const allRows = document.querySelectorAll(".call-list-row");
    try {
      const result = await postRequest("smartList/actionSmartItem", {
        listing: listing_id,
        agent: inputs["agentActive_SmartCallList"],
        action: actionTaken,
      });
      if (result.data.status == 200) {
        allRows[index].classList.add("fade-smart-row");
        setTimeout(() => {
        setSmartList(smartList.filter((f) => f.listing_id !== listing_id));
      }, 900);
      }else{
        allRows[index].classList.add("error-smart-row");
      }
    } catch (error) {
      console.error("Error on executing appraisal action:", error);
    }
  };

  function overRideActionSelect(bdid){
    let output =  {id:0, label: "Select Action"}
    if(typeof inputs["action-select_" +bdid] !== 'undefined'){
      if(inputs["action-select_" + bdid] !== 0){
        output.id = inputs["action-select_" + bdid];
        output.label = callList_selectOptions.filter((f)=>f.id == inputs["action-select_" + bdid]).map((x)=>x.name);
      }
    }
    return output;
  }
  // alert("Action taken for listing id: " + listing_id);
  return (
    <>
      {typeof inputs["agentActive_SmartCallList"] !== "undefined" &&
      Number(inputs["agentActive_SmartCallList"]) > 0 ? (
        <div className="modal smart-call-list scroll-snap-el">
          <div className="title-and-power">
            <h2 className="hm-modal-title">Open Appraisal Call List</h2>
            {elevatedAccess.includes(
              Number(sessionStorage.getItem("user-id"))
            ) ? (
              <>
                <span
                  title={"swap agent viewing"}
                  onClick={() => activateSmartCallViewing()}
                  className="material-symbols-outlined swap-icon control-icon"
                >
                  sync
                </span>
                <span
                  title={"turn off smart call list viewing"}
                  onClick={() => deactivateSmartCallViewing()}
                  className="material-symbols-outlined power-icon control-icon"
                >
                  mode_off_on
                </span>
              </>
            ) : null}
          </div>

          <h4 className="total">{smartList.length + " Total"}</h4>
          <p className="disclaimer">
            This list shows every appraisal you've completed in the last 12 months that hasn't been closed, listed, or sold by a competitor.
          </p>

          <div className="call-list-box">
            <div className="call-list-content">
              {smartList.length > 0
                ? smartList.map((x, index) => (
                    <div key={x.listing_id} className="call-list-row">
                      <div className="column">
                        <p title={x.Address}>
                          {shortenData(x.Address, "Address", 30)}
                        </p>
                      </div>
                      <div className="column">
                        <p title={x.Suburb}>
                          {shortenData(x.Suburb, "Suburb", 16)}
                        </p>
                      </div>
                      <div className="column">
                        <p title={x.Contact}>
                          {shortenData(x.Contact, "Contact", 20)}
                        </p>
                      </div>
                      <div className="column">
                        <p>{dateFormat(x.a_date, "DD-MM-YYYY")}</p>
                      </div>
                      <a
                        className="column show-under-900px"
                        href={
                          "https://mw.boxdice.com.au/main#appraisals/" +
                          x.listing_id
                        }
                        target="_blank"
                      >
                        B+D
                      </a>
                          <a
                        className="column hide-under-900px"
                        href={
                          "https://mw.boxdice.com.au/main#appraisals/" +
                          x.listing_id
                        }
                        target="_blank"
                      >
                        View in B+D
                      </a>

                      <div className="column col-action">
                        <Select_Input key={x.listing_id}
                          data={callList_selectOptions}
                          defaultTxt="Select Action"
                          desc="Appraisal Action Select"
                          defaultValue="0"
                          optionSelectedOnLoad={0}
                          overRideSelectedValue = {overRideActionSelect(x.listing_id)}
                          defaultSelectable={false}
                          inputName={"action-select_" + x.listing_id}
                          id={"action-select_" + x.listing_id}
                          optionId={"id"}
                          optionValue={"name"}
                          newStructureOptions={false}
                          updateSelectChange={updateSelectFields}
                          classes={"select-white oa-row-white-select"}
                        />
                        <Button
                          id={""}
                          classes={
                            typeof inputs["action-select_" + x.listing_id] !==
                            "undefined" && inputs["action-select_" + x.listing_id] !== 0
                              ? "btn-default btn-row-structure"
                              : "disabled-btn btn-row-structure"
                          }
                          buttonTxt={"Confirm"}
                          desc={
                            typeof inputs["action-select_" + x.listing_id] !==
                            "undefined"
                              ? "Confirm"
                              : "Select Action to Confirm"
                          }
                          disabled={
                            typeof inputs["action-select_" + x.listing_id] ==
                            "undefined"
                          }
                          type={"submit"}
                          onClickMethod={() =>
                            typeof inputs["action-select_" + x.listing_id] !==
                            "undefined"
                              ? actionAppraisal(x.listing_id, index, inputs["action-select_" + x.listing_id])
                              : null
                          }
                        />
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      ) : elevatedAccess.includes(
          Number(sessionStorage.getItem("user-id"))
        ) ? (
        <div className="scroll-snap-el">
          <div id="admin-smart-controller" className="admin-controller">
            <h4>Open Appraisal Call List</h4>
            <span
              title={"turn on viewing smart call list"}
              onClick={() => activateSmartCallViewing()}
              className="material-symbols-outlined power-icon control-icon"
            >
              mode_off_on
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
}
export default SmartCallList;
